import { useInstance } from './useInstance.js';
export function useProps() {
    return useInstance().props;
}
//# sourceMappingURL=useProps.js.map